import React from 'react';
import {Svg, Path } from 'react-native-svg';

const ChatDotsIcon = ({ size, color }) => {
    return (
        <Svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <Path d="M6 6H4V8H6V6Z" fill={color}/>
            <Path d="M8 6H10V8H8V6Z" fill={color}/>
            <Path d="M14 6H12V8H14V6Z" fill={color}/>
            <Path d="M0 2V18L4.8 14.4C5.14582 14.1396 5.56713 13.9992 6 14H16C17.1046 14 18 13.1046 18 12V2C18 0.89543 17.1046 0 16 0H2C0.89543 0 0 0.89543 0 2ZM2 14V2H16V12H5.334C4.90107 11.9988 4.47964 12.1393 4.134 12.4L2 14Z" fill={color}/>
        </Svg>
    );
};

export default ChatDotsIcon;
